const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

const generateNCPDetailUrl = (slug, page) => {
  return `${PUBLIC_URL}/mobil-baru-toyota/p/${slug}/${page}`;
};

generateNCPDetailUrl.defaultProps = {
  slug: 'agya',
  page: 'spesifikasi',
};

export default generateNCPDetailUrl;
